import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BackSystemOfficeProperties, branchBackFromServerProperties, BranchInformationProperties, BackSystemAllList, ParentBackSystemCompanies } from '../Models/BranchInformationProperties';
import { AgencyBaseDataProperties, CreditLimitChecking, CustomerCodes, ReportTypesAgency } from '../Models/AgencyMasterProperties';
import { B2BActiveBranches, ActiveBranches, ParentUsers, Agency_Branches } from '../Models/ActiveClasses';
import { AgencySupplierRightsdata } from '../Models/SuppliersProperties';
import { AgencyRightsProperties, ReturnToFrontPropertiesforAgency } from '../Models/AgencyRightsProperties';
import { Countries } from '../Models/Countries';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';

@Injectable({
  providedIn: 'root'
})
export class BranchService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  getCountries(): Observable<Countries[]> {
    return this.http.get<Countries[]>(this.baseUrl + '/PassengerInfo/GetAllCountries')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  GetBaseData(param): Observable<AgencyBaseDataProperties> {
    return this.http.get<AgencyBaseDataProperties>(this.baseUrl + '/AgencyMaster/GetAgencyBaseData/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  AddNewBranch(branchObj): Observable<branchBackFromServerProperties> {
    return this.http.post<branchBackFromServerProperties>(this.baseUrl + '/BranchInformation/AddNewBranch', branchObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateBranch(agencyObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BranchInformation/UpdateBranch', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBackSystemBranches(): Observable<ActiveBranches[]> {
    return this.http.get<ActiveBranches[]>(this.backSystemUrl + '/Branch/GetAllBranches')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetAllBranches(): Observable<BranchInformationProperties[]> {
    return this.http.get<BranchInformationProperties[]>(this.baseUrl + '/BranchInformation/GetAllBranches')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetBranchById(branchId: string): Observable<BranchInformationProperties> {
    return this.http.get<BranchInformationProperties>(this.baseUrl + '/BranchInformation/GetBranchById/' + branchId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetParentChildBranches(param): Observable<B2BActiveBranches[]> {
    return this.http.get<B2BActiveBranches[]>(this.baseUrl + '/BranchInformation/GetParentChildBranches/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }




  UserLimitCheck(agencyId, imidiatParent, userLimit): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/AgencyUsersLimit?agencyId=' + agencyId + '&imidiatParent=' + imidiatParent + '&userLimit=' + userLimit)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  GetSuppliersByParent(parentId:string): Observable<AgencySupplierRightsdata> {
    return this.http.get<AgencySupplierRightsdata>(this.baseUrl + '/Suppliers/GetSuppliersByParent?parentId='+parentId)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

  GetparentAgencyRights(param,user): Observable<AgencyRightsProperties> {
    return this.http.get<AgencyRightsProperties>(this.baseUrl + '/AgencyMaster/GetparentAgencyRights/' + param + '/' + user)
      .pipe(map((data: any) => {
        // //console.log(data);
        return data;
      }), catchError(error => {  return throwError(error); }))
  }

  CreateAdminUser(userObj): Observable<number> {
    return this.http.post<number>(this.baseUrl + '/Users/CreateUser', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateAdminUser(userObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/BranchInformation/UpdateBranchUserAdminRights', userObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateAgencyRights(agencyObj): Observable<ReturnToFrontPropertiesforAgency> {
    return this.http.post<ReturnToFrontPropertiesforAgency>(this.baseUrl + '/AgencyMaster/CreateAgencyRights', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UpdateAgencyRights(agencyObj): Observable<ReturnToFrontPropertiesforAgency> {
    return this.http.post<ReturnToFrontPropertiesforAgency>(this.baseUrl + '/AgencyMaster/UpdateAgencyRights', agencyObj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CreateAgencySupplierRights(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/Suppliers/CreateAgencySupplierRights', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

  CheckChildBranchesLimit(param, isAgency): Observable<number> {
    return this.http.get<number>(this.baseUrl + '/BranchInformation/CheckChildBranchesLimit/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckUsersLimit(param, isAgency): Observable<number> {
    return this.http.get<number>(this.baseUrl + '/Users/CheckUsersLimit/' + param + "/" + isAgency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CheckCreditLimitRightAgaintAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/AgencyMaster/CheckCreditLimitRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        //console.log(data);
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  GetAllReportTypes(): Observable<ReportTypesAgency[]> {
    return this.http.get<ReportTypesAgency[]>(this.baseUrl + '/AgencyMaster/GetAllReportTypes')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateUpdateManagers(obj): Observable<branchBackFromServerProperties> {
    return this.http.post<branchBackFromServerProperties>(this.baseUrl + '/BranchInformation/CreateManagersNew', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
 
  CreateBackSystemInfo(obj): Observable<branchBackFromServerProperties> {
    return this.http.post<branchBackFromServerProperties>(this.baseUrl + '/BranchInformation/CreateBranchSystemBackOffice', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }

  GetCheckLoginNameAvaliability(param): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BranchInformation/GetloginNameForAdminUser/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }


  GetCustomerCodeByID(param): Observable<CustomerCodes[]> {
    return this.http.post<CustomerCodes[]>(this.baseUrl + '/ERPBackOffice/CustomerCodes', param, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetBackSystemByid(branchId): Observable<BackSystemAllList[]> {
    return this.http.get<BackSystemAllList[]>(this.baseUrl + '/BranchInformation/GetBackSystemByID/' + branchId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  DeleteManager(managerId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "/AgencyMaster/DeleteManager?managerId=" + managerId)
      .pipe(map(data => {
        return data;
      }), catchError(error => {
        return throwError(error);
      }))
  }
  AgencyBranchLimitationRights(newAgencyId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "/AgencyMaster/AgencyBranchLimitationRights?newAgencyId=" + newAgencyId)
      .pipe(map(data => {
        return data;
      }), catchError(error => {
        return throwError(error);
      }))
  }



  //25-05-23 changes change
  GetUsersByParent(param, isAgency, agencyId): Observable<ParentUsers[]> {
    return this.http.get<ParentUsers[]>(this.baseUrl + '/AgencyMaster/GetUsersByParent/' + param + "/" + isAgency + "/" + agencyId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  //end

  //---------------------- 25-05-2023 This Section Is Just Updated To Test Parent Baranch Data ------------------------------//
  GetAgencyBaseDataForBranch(param): Observable<Agency_Branches[]> {
    return this.http.get<Agency_Branches[]>(this.baseUrl + '/AgencyMaster/GetAgencyBaseDataForBranch?param=' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetBaseDataForAgencyMaster(param): Observable<AgencyBaseDataProperties> {
    return this.http.get<AgencyBaseDataProperties>(this.baseUrl + '/AgencyMaster/GetBaseDataForAgencyMaster/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  AgencyBranchChildLimitationRights(agencyId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "/AgencyMaster/AgencyBranchChildLimitationRights?agencyId=" + agencyId)
      .pipe(map(data => {
        return data;
      }), catchError(error => {
        return throwError(error);
      }))
  }

  CheckParentCreditLimit(param, isAgency, branchId): Observable<CreditLimitChecking> {
    return this.http.get<CreditLimitChecking>(this.baseUrl + '/AgencyMaster/CheckParentCreditLimit/' + param + "/" + isAgency + "/" + branchId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetCompanyMaster(): Observable<CompanyMasterProperties[]> {
    return this.http.get<CompanyMasterProperties[]>(this.baseUrl + '/CompanyMaster/GetCompanyMasterForAgencies').pipe(map((data: CompanyMasterProperties[]) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }
  GetParentBackSystemCompanies=(parentId:string):Observable<ParentBackSystemCompanies>=>{
    return this.http.get<ParentBackSystemCompanies>(this.baseUrl+'/BranchInformation/GetParentBackSystemCompanies?parentId='+parentId)
    .pipe(map((data:ParentBackSystemCompanies)=>{
      return data;
    }),catchError(error=>{
      return throwError(error);
    }))
  }

  CheckUserEmailValidation(email: string, userId: number): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/BranchInformation/CheckEmailValidation?userEmail=' + email + '&userId=' + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
